import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { each, find, first } from 'lodash';
import { connect } from 'react-redux';
import { Modal, Tooltip, OverlayTrigger, Dropdown, MenuItem } from 'react-bootstrap';

import DateTimeDisplay from '../../../../components/date-time-display';
import { loadContactDispositions } from '../../CEActions';
import { getIndexedContacts } from '../../CEReducer';

const headerHeight = 40;
const rowHeight = 40;


class DispositionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTrackingId: null,
      expanded: {

      },
    };
    this.close = this.close.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }


  getCurrectTracking() {
    const { selectedTrackingId } = this.state;
    const { account } = this.props;
    const hasData = account !== null && account !== undefined;
    if (!hasData) {
      return null;
    }
    const accountTracking = account.tracking || {};
    let tracking = find(accountTracking.trackings, { tracking_id: selectedTrackingId });
    if (!tracking) {
      tracking = first(accountTracking.trackings);
    }
    return tracking;
  }

  close() {
    this.setState({ selectedTrackingId: null });
    this.props.onClose();
  }
  handleRowClick(contact) {
    const { program } = this.props;
    const tracking = this.getCurrectTracking();
    if (!tracking) {
      return;
    }
    const oppId = tracking.tv__opportunityId; // or sfa__opportunityId
    const contactId = contact.tv__contactId; // or sfa__contactId
    if (!oppId || !contactId) {
      return;
    }
    const clientId = program.client_id;
    const { expanded } = this.state;
    const isExpanded = expanded[contactId] === true;
    const newExpanded = { ...expanded, [contactId]: !isExpanded };
    this.setState({ expanded: newExpanded });
    const { activities } = contact;
    if (!activities) {
      this.props.dispatch(loadContactDispositions(clientId, oppId, contactId));
    }
  }

  renderActivities(activities) {
    return (
      <div style={{ backgroundColor: '#fff', padding: 10 }}>
        <table style={{ margin: 0 }} className="table table-condensed table-bordered table-striped">
          <thead>
            <tr>
              <th>Disposition Name</th>
              <th width="150" >Date</th>
              <th width="100" className="text-right">Disposition</th>
            </tr>
          </thead>
          <tbody>
            {activities.map((activity) => {
              const hasNote = activity.notes && activity.notes.length > 0;
              const tip = hasNote ? (<Tooltip id={`name-${activity.completed}`}><div>{activity.notes}</div></Tooltip>) : null;

              return (
                <tr key={activity.completed}>
                  <td>
                    {hasNote &&
                      <OverlayTrigger placement="top" overlay={tip}>
                        <span>{activity.dispositionName}</span>
                      </OverlayTrigger>
                    }
                    {!hasNote && <div>{activity.dispositionName}</div>}
                  </td>
                  <td><DateTimeDisplay value={activity.completed} format="short" /></td>
                  <td className="text-right">{activity.disposition}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderDropdown(trackings) {
    const selectedTracking = this.getCurrectTracking();
    return (<div>
      <Dropdown
        id="tracking-dropdown"
      >
        <Dropdown.Toggle block>
          {selectedTracking.sfa__opportunityName}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {trackings.map(tracking => (
            <MenuItem
              key={tracking.tracking_id}
              active={tracking.tracking_id === selectedTracking.tracking_id}
              onClick={() => { this.setState({ selectedTrackingId: tracking.tracking_id, expanded: {} }); }}
            >
              {tracking.sfa__opportunityName} (<DateTimeDisplay value={tracking.date} format="shortWithTime" />)
            </MenuItem>
            ))}
        </Dropdown.Menu>
      </Dropdown>
      <p />
    </div>);
  }

  render() {
    const { isOpen, account, indexedContacts } = this.props;
    const { expanded } = this.state;
    const hasData = account !== null && account !== undefined;
    if (!hasData) {
      return null;
    }
    const tracking = this.getCurrectTracking();
    if (!tracking) {
      return null;
    }
    const contacts = [];
    if (isOpen) {
      each(tracking.contacts, (contact) => {
        const id = contact.sfa__contactId;
        const isExpanded = expanded[contact.tv__contactId];
        let height = rowHeight;
        if (isExpanded) {
          if (contact.activities && contact.activities.status === 'loaded') {
            height = rowHeight + (contact.activities.activities.length * rowHeight) + headerHeight + 2;
          } else if (contact.activities && contact.activities.status === 'error') {
            height = rowHeight * 2.5;
          }
        }
  
        if (indexedContacts[id]) {
          contacts.push({
            ...indexedContacts[id],
            ...contact,
            height,
            isExpanded,
          });
        }
      });
    }
    const sortedData = contacts;

    return (
      <Modal bsSize="lg" show={isOpen} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{account.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.renderDropdown(account.tracking.trackings)}
            {contacts.length === 0 && <div>No records found.</div>}
            {contacts.length !== 0 &&
              <div>
                <table className="table table-bordered table-condensed table-striped">
                  <thead>
                    <tr>
                      <th width="30">&nbsp;</th>
                      <th width="99%">Contact</th>
                      <th>Last&nbsp;Activity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.map((contact) => {
                      const { isExpanded, activities, lastActivity } = contact;
                      const hasLastActivities = lastActivity !== null && lastActivity !== undefined;
                      const name = `${contact.first_name} ${contact.last_name}`;
                      const click = (e) => {
                        e.preventDefault();
                        this.handleRowClick(contact);
                      };
                      const rows = [];
                      rows.push((
                        <tr key={`${contact._id}-upper`}>
                          <td className="text-center" onClick={click} style={{ cursor: hasLastActivities ? 'pointer' : 'not-allowed' }}>
                            {hasLastActivities &&
                              <div>
                                {!isExpanded && <Fa name="plus-square-o" />}
                                {isExpanded &&
                                  <div>
                                    {activities &&
                                      <div>
                                        {activities.status === 'loading' && <Fa name="spinner" spin />}
                                        {activities.status !== 'loading' && <Fa name="minus-square-o" />}
                                      </div>
                                    }
                                    {!activities && <Fa name="minus-square-o" />}
                                  </div>
                                }
                              </div>
                            }
                            {!hasLastActivities && <Fa name="plus-square-o" className="invisible" />}
                          </td>
                          <td>
                            {hasLastActivities && <a href="" onClick={click}>{name}</a>}
                            {!hasLastActivities && <span>{name}</span>}
                          </td>
                          <td>
                            {hasLastActivities && <nobr><DateTimeDisplay value={lastActivity.completed} format="shortWithTime" /></nobr>}
                            {!hasLastActivities &&
                              <div>
                                {!contact.rejected && <div>Pending</div>}
                                {contact.rejected && <div>Rejected</div>}
                              </div>
                            }
                          </td>
                        </tr>
                      ));
                      if (isExpanded) {
                        rows.push((
                          <tr key={`${contact._id}-lower`}>
                            <td colSpan={3}>
                              {isExpanded && activities.status === 'loaded' && this.renderActivities(activities.activities)}
                              {isExpanded && activities.status === 'error' &&
                                <div className="alert alert-danger">
                                  {activities.errors.message}
                                </div>
                              }
                            </td>
                          </tr>
                        ));
                      }
                      return rows;
                    })}
                  </tbody>
                </table>
              </div>
            }
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

DispositionModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  account: PropTypes.object,
  program: PropTypes.object,
  indexedContacts: PropTypes.object.isRequired,
};
DispositionModal.defaultProps = {
  onClose: () => {},
};


function mapStateToProps(state) {
  return {
    indexedContacts: getIndexedContacts(state),
  };
}

export default connect(mapStateToProps)(DispositionModal);
